import { render, staticRenderFns } from "./SyncLoading.vue?vue&type=template&id=4615dc50&scoped=true&"
import script from "./SyncLoading.vue?vue&type=script&lang=js&"
export * from "./SyncLoading.vue?vue&type=script&lang=js&"
import style0 from "./SyncLoading.vue?vue&type=style&index=0&id=4615dc50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4615dc50",
  null
  
)

export default component.exports